export var CountryCallingCode;
(function (CountryCallingCode) {
    CountryCallingCode["CN"] = "86";
    CountryCallingCode["HK"] = "852";
    CountryCallingCode["MO"] = "853";
    CountryCallingCode["MM"] = "95";
    CountryCallingCode["CAMBODIA"] = "855";
    CountryCallingCode["DUBAI"] = "971";
    CountryCallingCode["PHILIPPINES"] = "63"; // Philippines
})(CountryCallingCode || (CountryCallingCode = {}));
//# sourceMappingURL=CountryCallingCode.js.map